import popover from "./popover";

/**
 * 积分兑换，根据课程的字段类型判断是否显示该支付方式
 * 支付宝支付，点击支付按钮，调用订单接口，订单接口返回一个地址（显示二维码出来，但是这块目前先在 二维码 下方显示一个去支付的操作，用于测试环境测试），js 创建 a 标签进行跳转支付
 * 其他支付，请求拿到结果后显示二维码
 */
  // 支付弹窗的操作配置
const PAY_CONFIG = {
    onQrHide: () => {}, // 支付二维码隐藏事件
    onConfirm: () => {}, // 确定事件
    onCancel: () => {}, // 取消事件
    onClose: () => {}, // 关闭事件
    onPaySuccess: () => {}, // 支付成功
    order: {}, // 订单信息
    isOpenVip: false, // 是否开通会员
    isTwoPay: false, // 是否是二次下单
  }
const PAY = {
  Integral: {
    type: 'Integral',
    text: '积分兑换',
    icon: require('@/assets/icon/points.png')
  },
  Alipay: {
    type: 'Alipay',
    text: '支付宝',
    icon: require('@/assets/icon/alPay.png')
  },
  WeChat: {
    type: 'WeChat',
    text: '微信',
    icon: require('@/assets/icon/wxPay.png')
  },
  UnionPay: {
    type: 'UnionPay',
    text: '聚合',
    icon: require('@/assets/icon/unionPay.png')
  },
}
// 积分兑换的支付方式
const INTEGRAL_PAY = { name: '积分兑换', type: PAY.Integral.type, id: null, tip: '', warn: '' }
export default {
  mixins: [popover],
  provide () {
    return {
      onShowPayModal: this.onShowPayModal,
    };
  },
  payTask: null,
  data () {
    return {
      PAY,
      qrCode: null,
      showPayQrPopover: false,
      disabledPayQrPopover: true,
      points: 0, // 用户可用积分
      payConfig: { ...PAY_CONFIG },
      payList: [ // 支付方式列表
        // {
        //   id: '', // id
        //   name: '', // 支付名称
        //   type: '', // 支付类型
        //   icon: '', // 支付图标
        //   tip: '', // 支付支付，在积分兑换的时候，需要提示用户还有多少可用积分
        //   warn: '', // 支付警告，在积分兑换的时候，积分不足需要提示用户
        // }
      ],
      showPayModal: false,
      currentPayMethod: '', // 当前的支付方式
      qrMap: {}, // 支付二维码地址，积分兑换不需要
      qr: '', // 支付二维码地址，积分兑换不需要
      orderNo: '', // 支付的订单编号
      loadPay: false
    }
  },
  computed: {
    // 获取订单真实金额，限时/限量使用的是 salePrice 字段，正常情况使用 price
    orderPrice () {
      const { salePrice, price, saleStatus, numLimit } = this.payConfig.order
      const isLimitTime = saleStatus === 1 && numLimit === 0 // 限时
      const isLimitNum = saleStatus === 1 && numLimit === 1 // 限量
      return (isLimitTime || isLimitNum) ? salePrice : price
    },
    payModalWidth () {
      const len = this.payList.length
      const MAX = 4, MIN = 3
      const PAY_CARD_WIDTH = 142
      const PAR_CARD_MARGIN = 16
      const PAY_MODAL_PADDING = 48
      return Math.max(MIN, Math.min(len, MAX)) * PAY_CARD_WIDTH + ((len - 1) * PAR_CARD_MARGIN) + PAY_MODAL_PADDING + 'px'
    }
  },
  methods: {
    /**
     * 显示支付弹窗，这块需要改动，如果 isPointBuy 是假值，就不需要获取用户可用积分
     * @param {Object} [config] 配置项
     * @param {function} [config.onQrHide] 支付二维码隐藏事件
     * @param {function} [config.onConfirm] 弹窗确定事件
     * @param {function} [config.onCancel] 弹窗取消事件
     * @param {function} [config.onClose] 弹窗关闭事件
     * @param {function} [config.onPaySuccess] 支付成功
     * @param {Object} [config.order] 订单信息
     * @param {boolean} [config.isOpenVip] 是否是会员订单
     * @param {boolean} [config.isTwoPay] 是否是二次下单
     */
    onShowPayModal (config = {}) {
      this.payConfig = Object.assign({}, PAY_CONFIG, {
        onQrHide: () => {
          if (!this.showPayModal) return;
          this.selectOrderStatus()
        }, // 默认隐藏事件
      }, config)
      // 二次支付
      if (this.payConfig.isTwoPay) {
        this.currentPayMethod = this.payConfig.order.tradeChannel
        this.twoOrderPay({ orderNo: this.payConfig.order.orderNo })
        this.startTimeout();
        return
      }
      this.showPayModal = true
      // 准备支付列表
      Promise.all([this.getPayList(), this.getPointCenter()]).then(([payListRes, pointCenterRes]) => {
        if (payListRes.code !== 0) {
          return this.$message.error(payListRes.msg)
        }
        if (pointCenterRes.code !== 0) {
          return this.$message.error(pointCenterRes.msg)
        }
        const { data: payList } = payListRes
        const { points } = pointCenterRes.data
        this.points = points
        this.payList = this.fillPayListByPoints(points, payList)
        this.currentPayMethod = this.payList[0].type
      })
    },
    onHidePayModal () {
      this.showPayModal = false
      const DIALOG_CLOSE_ANIMATION = 500
      setTimeout(this.clearPayCache, DIALOG_CLOSE_ANIMATION)
      this.stopTimeout();
    },
    // 获取支付方式列表
    getPayList () {
      return this.$post('/trading/api/paychannel')
    },
    // 获取可用积分
    getPointCenter () {
      return this.$get(`/trading/api/point/center/${this.$store.state.user.id}`)
    },
    /**
     * 根据可用积分，填充支付列表
     * @param {number} points 可用积分
     * @param {Array} payList 支付列表
     * @return {*[]} 拥有可用积分的支付列表，前提是可以用积分兑换的
     */
    fillPayListByPoints (points, payList) {
      const order = this.payConfig.order
      const list = []
      for (const pay of payList) {
        list.push({
          id: pay.id,
          name: pay.name,
          type: pay.type,
          icon: PAY[pay.type].icon
        })
      }
      if (order.isPointBuy) {
        // 积分兑换
        list.unshift({
          ...INTEGRAL_PAY,
          tip: `当前可用积分 ${points}`,
          warn: points < order.point ? '积分不够无法兑换' : '',
          icon: PAY.Integral.icon
        })
      }
      return list
    },
    /**
     * 支付入口，统一从这判断是普通订单支付还是会员订单支付
     * @param query
     */
    onPay (query = {}) {
      let tradeChannelId = query.tradeChannelId
      const isIntegral = this.currentPayMethod === PAY.Integral.type
      if (!tradeChannelId && !isIntegral) {
        tradeChannelId = this.payList.find(i => i.type === this.currentPayMethod).id
      }
      const INTEGRAL_PAY = 4, MONEY_PAY = 2
      const req = Object.assign({
        goodsId: this.payConfig.order.id,
        userId: this.$store.state.user.id,
        orderType: isIntegral ? INTEGRAL_PAY : MONEY_PAY,
        tradeChannelId,
      }, query)
      this[this.payConfig.isOpenVip ? 'vipOrderPay' : 'orderPay'](req)
      // 轮询
      this.startTimeout();
    },
    startTimeout () {
      this.$options.payTask = setTimeout(() => {
        // 接口出现错误的时候，是没有 orderNo 的
        if (!this.orderNo) {
          return;
        }
        this.selectOrderStatus();
      }, 2000)
    },
    stopTimeout () {
      clearTimeout(this.$options.payTask);
    },
    /**
     * 普通订单支付，积分兑换的话，该接口就是支付流程的最后一步，成功后隐藏弹窗，刷新页面数据
     *    对于其他支付来说，只是获取支付二维码的操作
     * 关于订单类型传值，积分商城中：
     *    商品类型（goodsType）    订单类型（orderType）
     *    课程    1  -  虚拟订单 4
     *    勋章    3  -  虚拟订单 4
     *    实物商品 2  -  实物订单 1
     * 选择支付方式的时候：
     *  积分支付：4 | 金钱支付 2
     * @param {Object} [query] 请求参数
     * @param {string | number} [query.goodsId] 商品 id
     * @param {string} [query.tradeChannelId] 支付渠道 id
     * @param {number} [query.orderType] 订单类型
     *
     */
    orderPay (query = {}) {
      const zengDom = document.getElementById('zeng')
      if (this.qrMap[this.currentPayMethod]) {
        this.qr = this.qrMap[this.currentPayMethod]
        // 订单支付，如果该支付方式存在，就直接显示弹框
        return this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
      }
      this.loadPay = true
      this.$post('/trading/api/shoporder/order', query).then((res) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        const result = res.data
        if (this.currentPayMethod !== PAY.Integral.type) {
          //TODO 支付获取qrcode 需校验
          this.qr = JSON.parse(result.payResult).qrcode;
          this.orderNo = result.orderNo
          this.qrMap[this.currentPayMethod] = this.qr
          this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
          return
        }
        // 积分兑换无需后续操作
        this.onHidePayModal()
        this.$message.success('兑换成功')
        this.payConfig.onPaySuccess()
      }).finally(() => {
        this.loadPay = false
      })
    },
    /**
     * 开通 vip 的订单支付
     * @param {Object} [query] 请求参数
     * @param {Object} [query] 请求参数
     * @param {string | number} [query.goodsId] 商品 id
     * @param {string} [query.tradeChannelId] 支付渠道 id
     * @param {number} [query.orderType = 3] 订单类型，会员订单固定 3
     */
    vipOrderPay (query) {
      const zengDom = document.getElementById('zeng')
      if (this.qrMap[this.currentPayMethod]) {
        this.qr = this.qrMap[this.currentPayMethod]
        // 订单支付，如果该支付方式存在，就直接显示弹框
        return this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
      }
      this.loadPay = true
      this.$post('/trading/api/shoporder/viporder', query).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        const result = res.data
        // this.qr = result.payResult
        this.qr = JSON.parse(result.payResult).qrcode
        this.orderNo = result.orderNo
        this.qrMap[this.currentPayMethod] = this.qr
        this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
      }).finally(() => this.loadPay = false)
    },
    /**
     * 订单二次支付
     * @param {Object} [query]
     * @param {string} [query.orderNo] 订单编号
     */
    twoOrderPay (query) {
      const zengDom = event.target
      if (this.qrMap[this.currentPayMethod]) {
        this.qr = this.qrMap[this.currentPayMethod]
        return this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
      }
      this.$get(`/trading/api/shoporder/twicepayment/${query.orderNo}`).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // 选中当前的订单渠道
        const result = res.data
        // this.qr = result.payResult
        this.qr = JSON.parse(result.payResult).qrcode
        this.orderNo = result.orderNo
        this.qrMap[this.currentPayMethod] = this.qr
        this.showPopover(zengDom, { onHide: this.payConfig.onQrHide })
      })
    },
    // 测试环境，需要发布上线前需要删除
    onDevAliPay () {
      const stopEventDom = document.querySelector('.stop-click')
      const aDom = document.createElement('a')
      aDom.href = this.qr
      aDom.target = '_blank'
      aDom.style.cssText = 'position: fixed; left: -999999px; top: -999999px'
      stopEventDom.appendChild(aDom)
      aDom.click()
      stopEventDom.removeChild(aDom)
    },
    /**
     * 查询订单状态，在二维码窗口关闭的时候
     */
    selectOrderStatus () {
      const PAY_SUCCESS = 3
      this.$get(`/trading/api/shoporder/orderStatus/${this.orderNo}`).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data.tradeStatus !== PAY_SUCCESS) {
          return this.startTimeout();
        }
        this.onHidePayModal()
        // 支付成功
        this.payConfig.onPaySuccess()
      })
    },
    clearPayCache () {
      this.qrCode = null
      this.points = 0
      this.payConfig = { ...PAY_CONFIG }
      this.payList = []
      this.currentPayMethod = ''
      this.orderNo = ''
      this.qr = ''
      this.qrMap = {}
    }
  },
  beforeDestroy () {
    this.stopTimeout();
  }
}
